import { PeriodType } from './PeriodPicker';
import clsx from 'clsx';
import React from 'react';
import { DateRange } from './DateRangeSelector';
import moment from 'moment/moment';

const toText = ({ firstDay, lastDay }: DateRange, period: PeriodType) => {
  switch (period) {
    case 'Day': {
      return `${moment(firstDay).format('MMMM D, YYYY')}`;
    }
    case 'Week': {
      const withinSameMonth = moment(firstDay).isSame(moment(lastDay), 'month');
      return withinSameMonth
        ? `${moment(firstDay).format('MMM D')} - ${moment(lastDay).format('D, YYYY')}`
        : `${moment(firstDay).format('MMM D')} - ${moment(lastDay).format('MMM D, YYYY')}`;
    }
    case 'Month':
      return `${moment(firstDay).format('MMMM YYYY')}`;
    case 'Quarter':
      const isSameYear = moment(firstDay).isSame(moment(lastDay), 'year');
      return isSameYear
        ? `${moment(firstDay).format('MMM')} - ${moment(lastDay).format('MMM YYYY')}`
        : `${moment(firstDay).format('MMM YYYY')} - ${moment(lastDay).format('MMM YYYY')}`;
    case 'Custom':
      return '';
    default:
      throw new Error(`unsupported period: ${period}`);
  }
};

export const DateRangeText = (props: {
  period: PeriodType;
  range: DateRange;
  align?: 'left' | 'center';
}) => {
  const { period, range, align } = props;
  return (
    <div className="dates-navigator__panel">
      <span
        className={clsx('date-range-selector__title', {
          'date-range-selector__title--day': period === 'Day',
          'date-range-selector__title--week': period === 'Week',
          'date-range-selector__title--month': period === 'Month',
          'date-range-selector__title--quarter': period === 'Quarter',
          'date-range-selector__title--custom': period === 'Custom',
          'text-left': align === 'left',
        })}
      >
        {toText(range, period)}
      </span>
    </div>
  );
};

export const SmallDateRangeText = (props: {
  period: PeriodType;
  range: DateRange;
  align?: 'left' | 'center';
}) => {
  const { period, range } = props;
  return (
    <div className="dates-navigator__panel">
      <span className="date-range-selector__title">{toText(range, period)}</span>
    </div>
  );
};
